var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5.25h-.75V20h1.5V6.75h7.5V20h1.5V5.25H4M8 8H6v2h2zm-2 3h2v2H6zm2 3H6v2h2zm-2 3h2v2H6zm5-9H9v2h2zm-2 3h2v2H9zm2 3H9v2h2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.25 8.25h8.5V20h-1.5V9.75h-5.5V20h-1.5V8.25M15 12h2v2h-2zm2 3h-2v2h2z",
    clipRule: "evenodd"
  })));
};
export default SvgBuilding;